export default {
  user: (state) => state.user,
  drawer: (state) => state.drawer,
  drawerMini: (state) => state.drawerMini,
  isAuthenticated(state) {
    return !_.isEmpty(state.user) && !_.isEmpty(state.accessToken);
  },
  sessionToken: (state) => state.sessionToken,
};
